import { useEffect, useRef, useState, useCallback } from "react";

export const useWebSocketInplay = (apiResponse,eventId,lineMarketRes, config) => {
  const [matchOdd1, setMatchOdd] = useState({});
  const [tideMatch1, setTideMatch] = useState({});
  const [lineMarket1, setLineMarket] = useState({});
  const [underOver1, setUnderOver] = useState({});

  const [bookmakerMarket1, setBookmakerMarket] = useState({});
  const [digitMArket1, setDigitMArket] = useState({});

  const [fancyData1, setFancyData] = useState([]);

  const [isConnectedd, setIsConnected] = useState(false);
  const [reconnectAttempts, setReconnectAttempts] = useState(0);

  const [marketIds, setMarketIds] = useState([]);
  const marketIdsRef = useRef([]);

  const [marketBMIds, setMarketBMIds] = useState([]);
  const marketBMIdsRef = useRef([]);

  const wsRef = useRef(null);
  const subscribeChannels = useRef([]);
  const heartbeatInterval = useRef(null);
  const reconnectTimeout = useRef(null);
  const mountedRef = useRef(true);
  const isReconnecting = useRef(false);
  const isConnecting = useRef(false);
  const reconnectAttemptsRef = useRef(0);

  // ADDED: interval ref to check lineMarketRes updates every 30s
  const lineCheckInterval = useRef(null);

  const marketTideTypes = ["TIED_MATCH"];
  const marketMatchOdds = ["Match Odds"];
  const marketTypes = ["MATCH_ODDS", "TOURNAMENT_WINNER", "WIN"];
  const marketKeys = ["OVER_UNDER_05", "OVER_UNDER_25", "OVER_UNDER_15"];
  let marketSortingMap = "";

  // Compute marketIds when matchdatas changes (runs only when matchdatas changes)
  useEffect(() => {
    console.debug("[WS] matchdatas changed:", apiResponse);
    if (apiResponse) {   
      try {
        if (!apiResponse?.matchData) {
          console.debug("[WS] No matchdatas.game — clearing marketIds");
          setMarketIds([]);
          setMarketBMIds([]);
          marketIdsRef.current = [];
          marketBMIdsRef.current = [];
          return;
        }
  
        let eventId = apiResponse?.matchData?.eventId;
        let dataBMId = apiResponse?.matchData?.markets?.bookmakers
          ?.map((item) => String(item.marketId))
          .filter(Boolean);
  
        let dataMOId = apiResponse?.matchData?.markets?.matchOdds
          ?.map((item) => String(item.marketId))
          .filter(Boolean);
  
          
        let mo = [...lineMarketRes,...Array.from(new Set(dataMOId))]
        console.log(lineMarketRes, dataMOId, mo,"1111111111111111111111");
  
        const uniqueMOIds = Array.from(new Set(dataMOId));
        const uniqueBMIds = Array.from(new Set(dataBMId));
  
        console.log("[WS] Computed uniqueMOIds:", mo);
        console.log("[WS] Computed uniqueBMIds:", uniqueBMIds);
  
        setMarketIds(mo);
        marketIdsRef.current = mo;
  
        setMarketBMIds(uniqueBMIds);
        marketBMIdsRef.current = uniqueBMIds;
      } catch (err) {
        console.error("[WS] Error computing marketIds from matchdatas:", err);
        setMarketIds([]);
        setMarketBMIds([]);
        marketIdsRef.current = [];
        marketBMIdsRef.current = [];
      }
    }
  }, [apiResponse]);

  // Cleanup WebSocket safely
  const cleanupWebSocket = useCallback(() => {
    console.log("[WS] cleanupWebSocket invoked");
    if (heartbeatInterval.current) {
      clearInterval(heartbeatInterval.current);
      heartbeatInterval.current = null;
      console.debug("[WS] Heartbeat interval cleared");
    }

    if (wsRef.current) {
      try {
        console.debug("[WS] Closing WebSocket instance");
        wsRef.current.close();
      } catch (e) {
        console.error("[WS] Error closing WebSocket:", e);
      }
      wsRef.current = null;
    }

    subscribeChannels.current = [];
    console.debug("[WS] subscribeChannels reset");

    if (mountedRef.current) {
      setIsConnected(false);
      console.debug("[WS] isConnected set to false (cleanup)");
    }
  }, []);

  // Handle reconnection with exponential backoff
  const reconnectWebSocket = useCallback(() => {
    if (!mountedRef.current) {
      console.debug("[WS] reconnect skipped: component unmounted");
      return;
    }
    if (isReconnecting.current) {
      console.debug("[WS] reconnect skipped: already reconnecting");
      return;
    }

    isReconnecting.current = true;
    console.warn("[WS] 🔄 Reconnecting WebSocket...");

    clearTimeout(reconnectTimeout.current);
    cleanupWebSocket();

    const backoffTime = Math.min(
      3000 * Math.pow(2, reconnectAttemptsRef.current),
      30000
    );
    console.log(
      `[WS] Reconnect backoffTime = ${backoffTime}ms (attempt ${reconnectAttemptsRef.current})`
    );

    reconnectTimeout.current = setTimeout(() => {
      if (!mountedRef.current) {
        console.debug(
          "[WS] reconnect aborted: component unmounted during timeout"
        );
        isReconnecting.current = false;
        return;
      }
      reconnectAttemptsRef.current += 1;
      setReconnectAttempts(reconnectAttemptsRef.current);
      console.log("[WS] Reconnect attempt #: ", reconnectAttemptsRef.current);
      isReconnecting.current = false;
      startWebSocket();
    }, backoffTime);
  }, [cleanupWebSocket]);

  // Forward declarations
  let handleOpen, handleMessage, handleClose, handleError, startWebSocket;

  // Main WebSocket initialization
  startWebSocket = useCallback(() => {
    console.debug("[WS] startWebSocket called");
    if (!config?.wssLink) {
      console.error("[WS] startWebSocket aborted: no config.wssLink");
      return;
    }
    if (isConnecting.current) {
      console.debug("[WS] startWebSocket aborted: already connecting");
      return;
    }
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      console.debug("[WS] startWebSocket aborted: socket already open");
      return;
    }
    if (wsRef.current && wsRef.current.readyState === WebSocket.CONNECTING) {
      console.debug("[WS] startWebSocket aborted: socket connecting");
      return;
    }
    if (!mountedRef.current) {
      console.debug("[WS] startWebSocket aborted: component unmounted");
      return;
    }

    try {
      isConnecting.current = true;
      console.log("[WS] Creating new WebSocket ->", config.wssLink);
      const ws = new WebSocket(config.wssLink);
      wsRef.current = ws;

      ws.addEventListener("open", handleOpen);
      ws.addEventListener("message", handleMessage);
      ws.addEventListener("close", handleClose);
      ws.addEventListener("error", handleError);
    } catch (error) {
      console.error("[WS] WebSocket initialization error:", error);
      isConnecting.current = false;
      reconnectWebSocket();
    }
  }, [config?.wssLink, reconnectWebSocket]);

  // WebSocket Open Handler
  handleOpen = useCallback(() => {
    if (!mountedRef.current) {
      console.debug("[WS] handleOpen called but component not mounted");
      return;
    }

    isConnecting.current = false;
    console.log("[WS] ✅ WebSocket connected");
    setIsConnected(true);

    reconnectAttemptsRef.current = 0;
    setReconnectAttempts(0);

    const ids = marketIdsRef.current || [];
    const idsBm = marketBMIdsRef.current || [];
    console.debug("[WS] handleOpen marketIdsRef.current =", ids);

    if (!ids.length) {
      console.warn(
        "[WS] ⚠️ No market IDs to subscribe to on open — waiting for data"
      );
      // still keep connected for when marketIds arrive
    } else {
      ids.forEach((marketId) => {
        const topic = `${config.Topic_Match_Odds}${marketId}`;
        if (!subscribeChannels.current.includes(topic)) {
          try {
            if (wsRef.current?.readyState === WebSocket.OPEN) {
              wsRef.current.send(
                JSON.stringify({ action: "subscribe", topic })
              );
              subscribeChannels.current.push(topic);
              console.log(`[WS] 📡 Subscribed to: ${topic}`);
            }
          } catch (error) {
            console.error(`[WS] Failed to subscribe to ${topic}:`, error);
          }
        } else {
          console.debug(`[WS] Already subscribed to: ${topic}`);
        }
      });
    }

    if (!idsBm.length) {
      console.warn(
        "[WS] ⚠️ No market IDs to subscribe to on open — waiting for data"
      );
      // still keep connected for when marketIds arrive
    } else {
      idsBm.forEach((marketId) => {
        const topic = `${config.Topic_Bookmaker}${marketId}`;
        if (!subscribeChannels.current.includes(topic)) {
          try {
            if (wsRef.current?.readyState === WebSocket.OPEN) {
              wsRef.current.send(
                JSON.stringify({ action: "subscribe", topic })
              );
              subscribeChannels.current.push(topic);
              console.log(`[WS] 📡 Subscribed to: ${topic}`);
            }
          } catch (error) {
            console.error(`[WS] Failed to subscribe to ${topic}:`, error);
          }
        } else {
          console.debug(`[WS] Already subscribed to: ${topic}`);
        }
      });
    }

    if (eventId === "") {
      console.warn(
        "[WS] ⚠️ No market IDs to subscribe to on open — waiting for data",eventId
      );
      // still keep connected for when marketIds arrive
    } else {
        const topic = `${config.Topic_Fancy}${eventId}`;
        if (!subscribeChannels.current.includes(topic)) {
          try {
            if (wsRef.current?.readyState === WebSocket.OPEN) {
              wsRef.current.send(
                JSON.stringify({ action: "subscribe", topic })
              );
              subscribeChannels.current.push(topic);
              console.log(`[WS] 📡 Subscribed to: ${topic}`);
            }
          } catch (error) {
            console.error(`[WS] Failed to subscribe to ${topic}:`, error);
          }
        } else {
          console.debug(`[WS] Already subscribed to: ${topic}`);
        }
    }

    // Heartbeat: Send ping every 10 seconds
    if (heartbeatInterval.current) {
      clearInterval(heartbeatInterval.current);
      heartbeatInterval.current = null;
      console.debug(
        "[WS] Cleared existing heartbeat interval before starting new one"
      );
    }

    heartbeatInterval.current = setInterval(() => {
      if (!mountedRef.current) return;

      if (wsRef.current?.readyState === WebSocket.OPEN) {
        try {
          wsRef.current.send(JSON.stringify({ action: "ping" }));
          console.debug("[WS] Sent heartbeat ping");
        } catch (error) {
          console.error("[WS] Heartbeat ping failed:", error);
        }
      } else if (wsRef.current?.readyState === WebSocket.CLOSED) {
        clearInterval(heartbeatInterval.current);
        heartbeatInterval.current = null;
        console.warn(
          "[WS] Heartbeat stopped — socket closed, scheduling reconnect"
        );
        reconnectWebSocket();
      }
    }, 10000);
  }, [config?.Topic_Match_Odds, reconnectWebSocket]);

  // WebSocket Message Handler
  handleMessage = useCallback(
    (event) => {
      if (!mountedRef.current) {
        console.debug("[WS] handleMessage called but component not mounted");
        return;
      }

      // console.debug('[WS] Raw message received:', event.data);
      try {
        const payload = JSON.parse(event.data);
        const { topic, marketData } = payload;

        if (topic && topic.startsWith(config.Topic_Match_Odds)) {
          try {
            const parsedData = JSON.parse(marketData);
            const marketId = topic.split("/").pop();
            // console.log(`[WS] Received market update for ${marketId}`);

            if (marketTideTypes.includes(parsedData.marketType)) {
              setTideMatch((prevMOData) => ({
                ...prevMOData,
                [`${marketId}`]: parsedData,
              }));
            }

            if (parsedData.marketType.endsWith("_LINE")) {
              if (parsedData.toString() !== null) {
                setLineMarket((prevMOData) => ({
                  ...prevMOData,
                  [`${marketId}`]: parsedData,
                }));
              }
            }

            if (marketKeys.includes(parsedData.marketType)) {
              setUnderOver((prevMOData) => ({
                ...prevMOData,
                [`${marketId}`]: parsedData,
              }));
            }

            if (
              marketMatchOdds.includes(parsedData.marketName) &&
              !parsedData.marketType.endsWith("_LINE")
            ) {
              const matchOddsRunners = parsedData.runners;
              marketSortingMap = matchOddsRunners.map((r) => r.runnerName);

              setMatchOdd((prev) => {
                const next = { ...prev, [marketId]: parsedData };
                return next;
              });
            }

            if (["WIN"].includes(parsedData.marketType)) {
              // console.log(parsedData,"parsedDataparsedDataparsedData");

              const runners = parsedData.runners || [];
              const names = runners.map((r) => r.runnerName);
              const isAZ = [...names].sort().join() === names.join(); // A->Z check

              marketSortingMap = isAZ ? "AZ" : "ZA";
              setMatchOdd((prev) => {
                const next = { ...prev, [marketId]: parsedData };
                return next;
              });
            }
          } catch (parseError) {
            console.error(
              "[WS] Invalid JSON in marketData:",
              parseError,
              "raw marketData:",
              marketData
            );
          }
        } else if (topic && topic.startsWith(config.Topic_Bookmaker)) {
          const parsedData = JSON.parse(marketData);
          const marketId = topic.split("/").pop();

          if (parsedData.marketType.toString() === "LAST_DIGIT") {
            setDigitMArket((prevBMData) => ({
              ...prevBMData,
              [`${marketId}`]: parsedData,
            }));
          } else {
            const savedOrder = marketSortingMap;
            if (savedOrder) {
              parsedData.runners.sort((a, b) => {
                return (
                  savedOrder.indexOf(a.runnerName) -
                  savedOrder.indexOf(b.runnerName)
                );
              });
            }
            setBookmakerMarket((prevBMData) => ({
              ...prevBMData,
              [`${marketId}`]: parsedData,
            }));
          }
        } else if (topic && topic.startsWith(config.Topic_Fancy)) {
          const parsedData = JSON.parse(marketData);
          let otherData = parsedData.filter(
            (item) => item.status.trim() !== "CLOSED"
          );
          setFancyData(otherData);
        } else if (payload && payload.action === "pong") {
          console.debug("[WS] Received app-level pong:", payload);
        } else if (payload && payload.action === "ping") {
          // server ping - reply with pong
          try {
            if (wsRef.current?.readyState === WebSocket.OPEN) {
              wsRef.current.send(JSON.stringify({ action: "pong" }));
              console.debug("[WS] Replied with pong to server ping");
            }
          } catch (err) {
            console.error("[WS] Failed to reply pong:", err);
          }
        } else {
          console.debug("[WS] Non-market message received:", payload);
        }
      } catch (error) {
        console.error(
          "[WS] Error parsing WebSocket message:",
          error,
          "raw:",
          event.data
        );
      }
    },
    [config?.Topic_Match_Odds]
  );

  // WebSocket Close Handler
  handleClose = useCallback(
    (ev) => {
      if (!mountedRef.current) {
        console.debug("[WS] handleClose called but component not mounted");
        return;
      }

      isConnecting.current = false;
      setIsConnected(false);
      console.warn("[WS] ⚠️ WebSocket connection closed:", ev);

      reconnectWebSocket();
    },
    [reconnectWebSocket]
  );

  // WebSocket Error Handler
  handleError = useCallback(
    (error) => {
      if (!mountedRef.current) {
        console.debug("[WS] handleError called but component not mounted");
        return;
      }

      isConnecting.current = false;
      setIsConnected(false);
      console.error("[WS] ❌ WebSocket error:", error);

      cleanupWebSocket();
      reconnectWebSocket();
    },
    [cleanupWebSocket, reconnectWebSocket]
  );

  // Effect: Handle tab visibility changes
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!mountedRef.current) return;

      console.debug("[WS] visibilitychange - hidden?", document.hidden);
      if (!document.hidden) {
        console.log("[WS] Tab visible - checking connection state");
        if (
          !isConnecting.current &&
          wsRef.current?.readyState !== WebSocket.OPEN
        ) {
          console.log("[WS] Tab visible - starting socket (if needed)");
          startWebSocket();
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [startWebSocket]);

  // Effect: Initialize WebSocket and cleanup (only once on mount)
  useEffect(() => {
    console.log("[WS] Hook mounted; config.wssLink =", config?.wssLink);
    if (!config?.wssLink) {
      console.error("[WS] WebSocket URL not configured");
      return;
    }

    mountedRef.current = true;

    if (marketIdsRef.current.length > 0) {
      console.log("[WS] marketIds exist on mount -> starting socket");
      startWebSocket();
    } else {
      console.log(
        "[WS] No marketIds on mount -> socket will start when data arrives"
      );
    }

    return () => {
      console.log("[WS] Hook unmounting - cleaning up");
      mountedRef.current = false;
      isConnecting.current = false;

      if (heartbeatInterval.current) {
        clearInterval(heartbeatInterval.current);
        heartbeatInterval.current = null;
        console.debug("[WS] Cleared heartbeat on unmount");
      }

      if (reconnectTimeout.current) {
        clearTimeout(reconnectTimeout.current);
        reconnectTimeout.current = null;
        console.debug("[WS] Cleared reconnect timeout on unmount");
      }

      if (wsRef.current) {
        wsRef.current.removeEventListener("open", handleOpen);
        wsRef.current.removeEventListener("message", handleMessage);
        wsRef.current.removeEventListener("close", handleClose);
        wsRef.current.removeEventListener("error", handleError);

        try {
          wsRef.current.close();
          console.debug("[WS] Closed wsRef on unmount");
        } catch (e) {
          console.error("[WS] Error closing wsRef on unmount:", e);
        }
        wsRef.current = null;
      }

      subscribeChannels.current = [];
      console.debug("[WS] subscribeChannels cleared on unmount");

      // Clear the added lineMarketRes check interval on unmount
      if (lineCheckInterval.current) {
        clearInterval(lineCheckInterval.current);
        lineCheckInterval.current = null;
        console.debug("[WS] Cleared lineMarketRes check interval on unmount");
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config?.wssLink]);

  // Effect: when marketIds change, (re)subscribe/unsubscribe as needed and start socket if missing
  useEffect(() => {
    console.debug("[WS] marketIds effect triggered:", marketIds);
    if (!mountedRef.current) return;

    marketIdsRef.current = marketIds;
    marketBMIdsRef.current = marketBMIds;

//     if (
//   marketIdsRef.current.length > 0 ||
//   marketBMIdsRef.current.length > 0
// ){
//       console.log("[WS] marketIds empty -> unsubscribing all if connected");
//       if (
//         wsRef.current?.readyState === WebSocket.OPEN &&
//         subscribeChannels.current.length
//       ) {
//         subscribeChannels.current.forEach((topic) => {
//           try {
//             wsRef.current.send(
//               JSON.stringify({ action: "unsubscribe", topic })
//             );
//             console.log(`[WS] 📵 Unsubscribed from: ${topic}`);
//           } catch (e) {
//             console.error(`[WS] Failed to unsubscribe from ${topic}:`, e);
//           }
//         });
//         subscribeChannels.current = [];
//       }
//       return;
//     }

    if (!wsRef.current || wsRef.current.readyState === WebSocket.CLOSED) {
      console.log(
        "[WS] Socket missing/closed -> starting socket to subscribe to new marketIds"
      );
      startWebSocket();
      return;
    }

    if (wsRef.current.readyState === WebSocket.OPEN) {
      const newTopics0 = marketIdsRef.current.map(
        (id) => `${config.Topic_Match_Odds}${id}`
      );

      const newTopics1 = marketBMIdsRef.current.map(
        (id) => `${config.Topic_Bookmaker}${id}`
      );

      const newTopics2 = `${config.Topic_Fancy}${eventId}`;

      const newTopics = [
        ...newTopics0,
        ...newTopics1,
        ...(newTopics2 ? [newTopics2] : []),
      ];

      console.debug(
        "[WS] Reconciling subscriptions. newTopics:",
        newTopics,
        "current:",
        subscribeChannels.current
      );

      // Unsubscribe topics that are no longer needed
      // subscribeChannels.current.forEach((topic) => {
      //   if (!newTopics.includes(topic)) {
      //     try {
      //       wsRef.current.send(
      //         JSON.stringify({ action: "unsubscribe", topic })
      //       );
      //       console.log(`[WS] 📵 Unsubscribed from: ${topic}`);
      //     } catch (error) {
      //       console.error(`[WS] Failed to unsubscribe from ${topic}:`, error);
      //     }
      //   }
      // });

      // Subscribe to new topics
      newTopics.forEach((topic) => {
        if (!subscribeChannels.current.includes(topic)) {
          try {
            wsRef.current.send(JSON.stringify({ action: "subscribe", topic }));
            subscribeChannels.current.push(topic);
            console.log(`[WS] 📡 Subscribed to: ${topic}`);
          } catch (error) {
            console.error(`[WS] Failed to subscribe to ${topic}:`, error);
          }
        } else {
          console.debug(`[WS] Already subscribed to: ${topic}`);
        }
      });

      subscribeChannels.current = newTopics.slice();
      console.debug(
        "[WS] Subscriptions reconciled ->",
        subscribeChannels.current
      );
    }
  }, [marketIds,marketBMIds,eventId, config?.Topic_Match_Odds, startWebSocket]);

  const resubscribeIntervalRef = useRef(null);

useEffect(() => {
  // clear old interval if any
  if (resubscribeIntervalRef.current) {
    clearInterval(resubscribeIntervalRef.current);
    resubscribeIntervalRef.current = null;
  }

  const checkAndResubscribe = () => {
    if (!mountedRef.current) return;

    // socket must be open
    if (wsRef.current?.readyState !== WebSocket.OPEN) return;

    // already subscribed → nothing to do
    if (subscribeChannels.current.length > 0) return;

    console.warn("[WS] ⚠️ No active subscriptions — retrying subscribe");

    const ids = marketIdsRef.current || [];
    const bmIds = marketBMIdsRef.current || [];

    // Match Odds
    ids.forEach((marketId) => {
      const topic = `${config.Topic_Match_Odds}${marketId}`;
      try {
        wsRef.current.send(JSON.stringify({ action: "subscribe", topic }));
        subscribeChannels.current.push(topic);
        console.log(`[WS] 🔁 Re-subscribed: ${topic}`);
      } catch (e) {
        console.error(`[WS] Failed to re-subscribe ${topic}`, e);
      }
    });

    // Bookmaker
    bmIds.forEach((marketId) => {
      const topic = `${config.Topic_Bookmaker}${marketId}`;
      try {
        wsRef.current.send(JSON.stringify({ action: "subscribe", topic }));
        subscribeChannels.current.push(topic);
        console.log(`[WS] 🔁 Re-subscribed: ${topic}`);
      } catch (e) {
        console.error(`[WS] Failed to re-subscribe ${topic}`, e);
      }
    });

    // Fancy
    if (eventId) {
      const topic = `${config.Topic_Fancy}${eventId}`;
      try {
        wsRef.current.send(JSON.stringify({ action: "subscribe", topic }));
        subscribeChannels.current.push(topic);
        console.log(`[WS] 🔁 Re-subscribed: ${topic}`);
      } catch (e) {
        console.error(`[WS] Failed to re-subscribe ${topic}`, e);
      }
    }
  };

  // run every 15 seconds
  resubscribeIntervalRef.current = setInterval(checkAndResubscribe, 15000);

  return () => {
    if (resubscribeIntervalRef.current) {
      clearInterval(resubscribeIntervalRef.current);
      resubscribeIntervalRef.current = null;
    }
  };
}, [
  eventId,
  config?.Topic_Match_Odds,
  config?.Topic_Bookmaker,
  config?.Topic_Fancy,
]);


  // ---------------------------------------------------------------------------
  // ADDED: Auto-subscribe for lineMarketRes updates (runs immediately and every 30s)
  // Purpose: lineMarketRes updates every ~30s; ensure any new market ids from
  //          lineMarketRes are subscribed if the WebSocket is open and not
  //          already subscribed. Also add new ids into marketIds state/ref so
  //          existing reconciliation logic picks them up.
  // ---------------------------------------------------------------------------
  useEffect(() => {
    // Clear any existing interval first
    if (lineCheckInterval.current) {
      clearInterval(lineCheckInterval.current);
      lineCheckInterval.current = null;
    }

    const checkAndSubscribe = () => {
      if (!mountedRef.current) return;
      if (!config?.Topic_Match_Odds) return;

      try {
        const incoming = Array.isArray(lineMarketRes)
          ? lineMarketRes.map((id) => String(id)).filter(Boolean)
          : [];

        // unique incoming ids
        const uniqueIncoming = Array.from(new Set(incoming));

        if (!uniqueIncoming.length) return;

        // For each incoming id: if not present in marketIdsRef, add it and
        // trigger state update so other effects know about it. Then subscribe
        // immediately if socket is open and topic not already subscribed.
        uniqueIncoming.forEach((id) => {
          const topic = `${config.Topic_Match_Odds}${id}`;

          // add to marketIds refs/state so main effect sees it
          if (!marketIdsRef.current.includes(id)) {
            marketIdsRef.current = [...marketIdsRef.current, id];
            setMarketIds((prev) => Array.from(new Set([...(prev || []), id])));
            console.log(`[WS] ADDED id to marketIds from lineMarketRes: ${id}`);
          }

          // subscribe immediately if socket open and not already subscribed
          if (!subscribeChannels.current.includes(topic)) {
            if (wsRef.current?.readyState === WebSocket.OPEN) {
              try {
                wsRef.current.send(JSON.stringify({ action: "subscribe", topic }));
                subscribeChannels.current.push(topic);
                console.log(`[WS] 📡 (auto) Subscribed to: ${topic}`);
              } catch (err) {
                console.error(`[WS] Failed to auto-subscribe to ${topic}:`, err);
              }
            } else {
              console.debug(`[WS] Socket not open - will subscribe to ${topic} when it opens`);
            }
          }
        });
      } catch (err) {
        console.error("[WS] Error in lineMarketRes auto-subscribe check:", err);
      }
    };

    // Run immediately and then every 30s
    checkAndSubscribe();
    lineCheckInterval.current = setInterval(checkAndSubscribe, 30000);

    return () => {
      if (lineCheckInterval.current) {
        clearInterval(lineCheckInterval.current);
        lineCheckInterval.current = null;
      }
    };
  }, [lineMarketRes, config?.Topic_Match_Odds]);

  return {
    matchOdd1,
    tideMatch1,
    lineMarket1,
    underOver1,
    bookmakerMarket1,
    digitMArket1,
    fancyData1,
    isConnectedd,
    reconnectAttempts,
  };
};
